import React, {useState, useEffect} from 'react'
import _, { capitalize } from 'lodash'
import { Row, Col, Divider } from 'antd'
import styled from 'styled-components'
import { RangeColors } from '../../../utils'

import HealthCard from '../../../components/healthScore/card'
import Information from '../../../components/UI/extraInformation'

import Left from '../../../asserts/images/placeholder/balance-l.svg'
import Middle from '../../../asserts/images/placeholder/balance-m.svg'
import Right from '../../../asserts/images/placeholder/balance-r.svg'
import LeftFemale from '../../../asserts/images/physical-assessment/Balance-l-female.svg'
import MiddleFemale from '../../../asserts/images/physical-assessment/Balance-m-female.svg'
import RightFemale from '../../../asserts/images/physical-assessment/Balance-r-female.svg'
import QuietStandImage from '../../../asserts/images/physical-assessment/ic-quiet-stand.png'
import QuietStandImageMale from '../../../asserts/images/physical-assessment/QuietStandMale.svg'
import SingleLegStanceImage from '../../../asserts/images/physical-assessment/ic-single-let-stance.svg'
import SingleLegStanceImageFemale from '../../../asserts/images/physical-assessment/SingleLegStanceFemale.svg'

import AsymmetryChart from '../components/AsymmetryChart'
import HideWrap from '../../../components/assessmentReview/comp/hideWrap'
import { SectionStyle } from '../index.styled'
import { MovementMetricCard } from './MovementQualitySection'
import classNames from 'classnames'
import { ScoreColorGroup } from '../components/Widgets'
import { getRangeAgeScopes } from '../../../api'
import { getMetricById } from '../../../api'
import LowLevelMetrics from '../../../components/assessmentReview/comp/LowlevelMetrics'
import { formatDisplayName, getRangeByAgeAndGender } from './LowlevelMetricsHelpers'
import ConditionalHideWrap from '../../../components/assessmentReview/comp/ConditionalHidewrap'

const Container = styled.section`
  ${SectionStyle}

  .single-leg-stance-status-list {
    padding-left: 22.57%;
    color: #4c6072;

    & > div {
      border-bottom: 1px solid #e6e9f2;
      height: 64px;
      &:last-child {
        border-bottom: none;
      }
    }
    .status {
      padding: 5px 12px;
      border-radius: 6px;
      color: white;
      font-weight: 600;
    }
    .optimal {
      background-color: green;
    }
  }
`

const BalanceContainer = styled.div`
  color: #4c6072;
  margin-bottom: 90px;
  .range-list {
    margin-bottom: 22px;
    display: flex;
    justify-content: flex-end;
    list-style: none;
    font-size: 12px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: rgba(50, 58, 70, 0.5);
    &.center {
      display: block;
      text-align: center;
      padding: 0;
      margin-left: -24px;
      margin-top: 24px;
      li {
        display: inline-block;
      }
    }
    li {
      padding-left: 24px;
    }
    span {
      display: inline-block;
      width: 10px;
      height: 10px;
      margin-right: 5px;
    }
  }
  .ant-col-12 > div {
    background: rgba(38, 67, 130, 0.05);
    border-radius: 8px;
    padding: 32px;
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    text-transform: capitalize;
    letter-spacing: 0.3px;
    font-size: 24px;
    .score {
      color: #0d2350;
      font-family: 'Gilroy-Bold';
      text-align: right;
    }
    .level {
      font-family: 'Gilroy-Bold';
      font-size: 16px;
    }
    .previous {
      font-family: 'Gilroy';
      font-size: 15px;
      color: #4c6072;
    }
  }
  .balance-layout {
    margin-top: 50px;
    font-size: 15px;
    text-align: center;
    .name {
      margin: 30px 0;
    }
    .image {
      position: relative;
      .values {
        position: absolute;
        display: flex;
        justify-content: space-between;
        width: 100%;
        top: 105px;
        padding: 0 60px;
        div {
          background: #f4f6f9;
          width: 48px;
          height: 48px;
          border-radius: 100%;
          line-height: 48px;
          font-size: 18px;
          color: #0d2350;
          font-family: 'Gilroy-Bold';
        }
      }
    }
  }
  .chart-container {
    position: relative;
    padding-bottom: 160px;
    & > div {
      position: absolute;
    }
    .label {
      top: 60%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 12px;
      text-transform: uppercase;
      .value {
        font-size: 24px;
      }
    }
  }
`

const { red, yellow, green } = RangeColors
const Tips = [
  {
    name: 'Optimal',
    color: green
  },
  {
    name: 'Concern',
    color: yellow
  },
  {
    name: 'At risk',
    color: red
  }
]

export default function BalanceSection(props) {
  const {
    ageScopes,
    person,
    hideSectionHandle,
    hideSection,
    arDetail: { notes, status },
    save,
    onScoreChangeHandle,
    cancelEdit,
    handleCommendSave,
    updateEditingCount,
    dataList,
    compareData,
    view,
    loginRole,
    data: {
      Composit_Reach_Distance_Left,
      Composit_Reach_Distance_Right,
      anterior_reach_left,
      anterior_reach_right,
      anterior_reach_diff,
      postero_medial_reach_left,
      postero_medial_reach_right,
      postero_medial_reach_diff,
      postero_lateral_reach_left,
      postero_lateral_reach_right,
      postero_lateral_reach_diff,
      eyes_closed_lt_10_left,
      eyes_closed_lt_10_right,
      eyes_open_lt_10_left,
      eyes_open_lt_10_right,
      mean_force_asymmetry,
      total_excursion,
      total_excursion_left,
      total_excursion_right,
      quiet_stand_total_excursion_asymmetry,
      single_leg_total_excursion_asymmetry
    }
  } = props

  const [valueResults, setValueResults] = useState([])

  useEffect(() => {
    fetchBodyCompMetricsDetails()
  }, [])

  const fetchBodyCompMetricsDetails = async () => {
    const metricsWithSections = [
      'mean_force_asymmetry',
      'total_excursion',
      'total_excursion_left',
      'total_excursion_right',
      'total_time_left',
      'total_time_right'
    ]

    const ageScopes = (await getRangeAgeScopes()).age_scope

    const biomarkerDetailsPromises = metricsWithSections.map(async (metricKey) => {
      const metric = props.data[metricKey]

      if (!metric) {
        return null
      }

      if (['orange', 'red', 'yellow'].includes(metric.color)) {
        const conventionalRanges = getRangeByAgeAndGender(
          metric.ranges,
          person,
          ageScopes
        )

        if (metric && metric.metricId) {
          const biomarkerDetail = await getMetricById(
            metric.metricId,
            null,
            'physical_assessments'
          )

          const introduction = biomarkerDetail && biomarkerDetail.physical_assessment.introduction ? biomarkerDetail.physical_assessment.introduction : 'No introduction available'
          return {
            displayName: formatDisplayName(metricKey),
            value: metric.value,
            color: metric.color,
            level: metric.level,
            conventionalRanges,
            biomarkerDetail,
            introduction,
            sectionName: 'Balance'
          }
        }
      }

      return null
    })

    const results = (await Promise.all(biomarkerDetailsPromises)).filter(
      (result) => result !== null
    )

    setValueResults(results)
  }

  const data = dataList.find((item) => item.name === 'Balance') || {}
  const compare = compareData.find((item) => item.name === 'Balance') || {}

  const balance = notes.find((item) => item.pillar === 'balance')
  const gender = person && person.profile && person.profile.gender

  const metrics = [
    {
      name: 'Quiet Stand',
      image: gender === 'male' ? QuietStandImageMale : QuietStandImage,
      imageStyle: {
        width: gender === 'male' ? 100 : 140
      },
      bars: [
        {
          ...mean_force_asymmetry,
          name: 'Mean Force Asymmetry'
        },
        {
          ...total_excursion,
          name: 'Total Excursion'
        }
      ],
      asymmetry: {
        ...quiet_stand_total_excursion_asymmetry
      },
      asymmetryText: 'Total Excursion Asymmetry'
    },
    {
      name: 'Single leg stance',
      image: gender === 'male' ? SingleLegStanceImage : SingleLegStanceImageFemale,
      imageStyle: {
        width: 150
      },
      bars: [
        {
          ...total_excursion_right,
          name: 'Total Excursion Right'
        },
        {
          ...total_excursion_left,
          name: 'Total Excursion Left'
        }
      ],
      asymmetry: {
        ...single_leg_total_excursion_asymmetry
      },
      asymmetryText: 'Total Excursion Asymmetry'
    }
  ]
  return (
    <Container>
      <h1 className="ar-section-title">Balance</h1>
      <ConditionalHideWrap
        name="Balance - summary"
        title="summary"
        syncStatus={hideSectionHandle}
        status={hideSection}
        view={view}
        isHealthRisk={true}
        condition={
            view === 'Draft' || (view !== 'Draft' && !hideSection.includes('Balance - summary'))
        }
      >
        <h3 className="ar-section card-title">Summary</h3>
        <HealthCard
          {...data}
          compare={compare}
          save={save}
          loginRole={loginRole}
          status={view === 'Draft' ? 'Draft' : 'Opened'}
          onChangeHandle={onScoreChangeHandle}
          disEdit={status === 1 || view === 'Preview'}
          cancel={cancelEdit}
        />
        <Information
          title="COMMENT/NOTE"
          disMarkDone={true}
          initialValue={balance ? balance.memo : ''}
          status={view === 'Draft' ? 'Draft' : 'Opened'}
          updateCommend={(value, status) =>
            handleCommendSave(value, 'balance', status)
          }
          updateEditingCount={updateEditingCount}
        />
      </ConditionalHideWrap>

      <Divider />
      <ConditionalHideWrap
        name="Balance - Movement Efficiency Y Balance"
        title="Movement Efficiency Y Balance"
        syncStatus={hideSectionHandle}
        status={hideSection}
        view={view}
        condition={
            view === 'Draft' || (view !== 'Draft' && !hideSection.includes('Balance - Movement Efficiency Y Balance'))
        }
      >
        <h3 className="ar-section-card-title">Movement Efficiency Y Balance</h3>
        <BalanceContainer>
          <Row gutter={26}>
            <Col span={12}>
              <div>
                <div>
                  Composite Score Left
                  <div
                    className="level"
                    style={{
                      color: RangeColors[Composit_Reach_Distance_Left.color]
                    }}
                  >
                    {Composit_Reach_Distance_Left.level}
                  </div>
                </div>
                <div
                  className="score"
                  style={{
                    color: RangeColors[Composit_Reach_Distance_Left.color]
                  }}
                >
                  {_.isNumber(Composit_Reach_Distance_Left.value)
                    ? Composit_Reach_Distance_Left.value
                    : '--'}

                    {/* {ui_version && Composit_Reach_Distance_Left.previous && (
                      <div className="previous">
                        Previous Score – {Composit_Reach_Distance_Left.previous}
                      </div>
                    )} */}
                  </div>
                </div>
              </Col>
              <Col span={12}>
                <div>
                  <div>
                    Composite Score Right
                    <div
                      className="level"
                      style={{
                        color: RangeColors[Composit_Reach_Distance_Right.color]
                      }}
                    >
                      {Composit_Reach_Distance_Right.level}
                    </div>
                  </div>
                  <div
                    className="score"
                    style={{
                      color: RangeColors[Composit_Reach_Distance_Right.color]
                    }}
                  >
                    {_.isNumber(Composit_Reach_Distance_Right.value)
                      ? Composit_Reach_Distance_Right.value
                      : '--'}

                    {/* {ui_version && Composit_Reach_Distance_Right.previous && (
                      <div className="previous">
                        Previous Score – {Composit_Reach_Distance_Right.previous}
                      </div>
                    )} */}
                  </div>
                </div>
              </Col>
            </Row>

          <Row type="flex" justify="space-between" className="balance-layout">
            <Col span={8}>
              <div className="image">
                {gender === 'male' ? (
                  <img src={Left} alt="placeholder" />
                ) : (
                  <img src={LeftFemale} alt="placeholder" />
                )}                
                <div className="values">
                  <div>
                    {_.isNumber(anterior_reach_right)
                      ? anterior_reach_right
                      : '--'}
                  </div>
                  <div>
                    {_.isNumber(anterior_reach_left)
                      ? anterior_reach_left
                      : '--'}
                  </div>
                </div>
              </div>
              <div className="name">Anterior Reach Difference (%)</div>
              <AsymmetryChart
                metric={anterior_reach_diff}
                ageScopes={ageScopes}
                person={person}
              />
              <div>
                Previous -{' '}
                {_.isNumber(anterior_reach_diff.previous) &&
                  anterior_reach_diff.previous + anterior_reach_diff.unit}
              </div>
            </Col>
            <Col span={8}>
              <div className="image">
                {gender === 'male' ? (
                  <img src={Middle} alt="placeholder" />
                ) : (
                  <img src={MiddleFemale} alt="placeholder" />
                )} 
                <div className="values">
                  <div>
                    {_.isNumber(postero_medial_reach_right)
                      ? postero_medial_reach_right
                      : '--'}
                  </div>
                  <div>
                    {_.isNumber(postero_medial_reach_left)
                      ? postero_medial_reach_left
                      : '--'}
                  </div>
                </div>
              </div>
              <div className="name">Posterior Medial Reach Difference (%)</div>
              <AsymmetryChart
                metric={postero_medial_reach_diff}
                ageScopes={ageScopes}
                person={person}
              />
              <div>
                Previous -{' '}
                {_.isNumber(postero_medial_reach_diff.previous) &&
                  postero_medial_reach_diff.previous +
                    postero_medial_reach_diff.unit}
              </div>
            </Col>
            <Col span={8}>
              <div className="image">
                {gender === 'male' ? (
                  <img src={Right} alt="placeholder" />
                ) : (
                  <img src={RightFemale} alt="placeholder" />
                )} 
                <div className="values">
                  <div>
                    {_.isNumber(postero_lateral_reach_right)
                      ? postero_lateral_reach_right
                      : '--'}
                  </div>
                  <div>
                    {_.isNumber(postero_lateral_reach_left)
                      ? postero_lateral_reach_left
                      : '--'}
                  </div>
                </div>
              </div>
              <div className="name">Posterior Lateral Reach Difference (%)</div>
              <AsymmetryChart
                metric={postero_lateral_reach_diff}
                ageScopes={ageScopes}
                person={person}
              />
              <div>
                Previous -{' '}
                {_.isNumber(postero_lateral_reach_diff.previous) &&
                  postero_lateral_reach_diff.previous +
                    postero_lateral_reach_diff.unit}
              </div>
            </Col>
          </Row>
          <ul className="range-list center">
            {Tips.map((item, index) => (
              <li key={index}>
                <span style={{ background: item.color }} /> {item.name}
              </li>
            ))}
          </ul>
        </BalanceContainer>
      </ConditionalHideWrap>
      <Divider />
      <ScoreColorGroup domain={'balance'} />
      <ConditionalHideWrap
        name="Balance - Quiet Stand"
        title="Quiet Stand"
        syncStatus={hideSectionHandle}
        status={hideSection}
        view={view}
        condition={
            view === 'Draft' || (view !== 'Draft' && !hideSection.includes('Balance - Quiet Stand'))
        }
      >
        <MovementMetricCard
          height={'400px'}
          nameMarginTop={'0px'}
          {...metrics[0]}
          {...{
            person,
            ageScopes
          }}
        />
      </ConditionalHideWrap>
      <Divider />
      <ConditionalHideWrap
        name="Balance - Single Leg Stance"
        title="Single Leg Stance"
        syncStatus={hideSectionHandle}
        status={hideSection}
        view={view}
        condition={
            view === 'Draft' || (view !== 'Draft' && !hideSection.includes('Balance - Single Leg Stance'))
        }
      >
        <MovementMetricCard
          height={'400px'}
          nameMarginTop={'0px'}
          {...metrics[1]}
          {...{
            person,
            ageScopes
          }}
        />
        <div className="single-leg-stance-status-list">
          <Row align={'middle'}>
            <Col span={4}>
              <span>Side</span>
            </Col>
            <Col span={8}>
              <strong>Balance Time Eyes Open</strong>
            </Col>
            <Col>
              <strong>Balance Time Eyes Closed</strong>
            </Col>
          </Row>
          <Row align={'middle'}>
            <Col span={4}>
              <span>Left</span>
            </Col>
            <Col span={8}>
              <span
                className={classNames('status')}
                style={{
                  backgroundColor:
                    RangeColors[eyes_open_lt_10_left.level] || 'lightgray'
                }}
              >
                {eyes_open_lt_10_left.level
                  ? capitalize(eyes_open_lt_10_left.level)
                  : '--'}
              </span>
            </Col>
            <Col>
              <span
                className={classNames('status')}
                style={{
                  backgroundColor:
                    RangeColors[eyes_closed_lt_10_left.level] || 'lightgray'
                }}
              >
                {eyes_closed_lt_10_left.level
                  ? capitalize(eyes_closed_lt_10_left.level)
                  : '--'}
              </span>
            </Col>
          </Row>
          <Row align={'middle'}>
            <Col span={4}>
              <span>Right</span>
            </Col>
            <Col span={8}>
              <span
                className={classNames('status')}
                style={{
                  backgroundColor:
                    RangeColors[eyes_open_lt_10_right.level] || 'lightgray'
                }}
              >
                {eyes_open_lt_10_right.level
                  ? capitalize(eyes_open_lt_10_right.level)
                  : '--'}
              </span>
            </Col>
            <Col>
              <span
                className={classNames('status')}
                style={{
                  backgroundColor:
                    RangeColors[eyes_closed_lt_10_right.level] || 'lightgray'
                }}
              >
                {eyes_closed_lt_10_right.level
                  ? capitalize(eyes_closed_lt_10_right.level)
                  : '--'}
              </span>
            </Col>
          </Row>
        </div>
      </ConditionalHideWrap>
      <LowLevelMetrics metricValues={valueResults} hideSection={hideSection} view={view} hideSectionHandle={hideSectionHandle} />

      </Container>
  )
}
